import './cards-style.scss'
import { addCommas } from '../../../rewardsAndRecognitionHelper/utils.js';

const CustomCards = ({
    Icon,
    pointAmount,
    cardTitle,
    customCardsClassName,
    cardColor,
    badgeText,
}) => {
    return (
        <div style={{ backgroundColor: cardColor, boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)' }} className={`${customCardsClassName} custom-cards`}>
            <div className='points-detail'>
                <div className='reward-point-img'>
                    <Icon alt='img' className="custom-card-icon" />
                </div>
                <div className='about-points'>
                    <div className='point-amount'>{(pointAmount && addCommas(pointAmount)) ?? 0}</div>
                    <div className='point-info'>{cardTitle}</div>
                    {badgeText ? (
                        <div className='custom-card-badge' style={{ color: cardColor }}>
                            {badgeText}
                        </div>
                    ) : null}
                </div>
            </div>
        </div>
    )
}

export default CustomCards